// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider_slider__MT8eV {
    margin: 7px 6px;
    position: relative;
    background: var(--color-136);
    -ms-touch-action: none;
    touch-action: none;

    height: 6px;
    border-radius: 2px;
    cursor: pointer;
}
.slider_sliderFill__t6rjG {
    display: block;

    height: 100%;
    background-color: var(--color-101);
    border-radius: 10px;
    top: 0;
}
.slider_sliderHandle__oh-8Q {
    background: var(--color-106);
    border: 2px solid var(--color-113);
    display: inline-block;
    position: absolute;

    width: 12px;
    height: 12px;
    border-radius: 12px;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
}
.slider_sliderEnd__Y6hK7 {
    background: var(--color-132);
    display: inline-block;
    position: absolute;

    width: 6px;
    height: 6px;
    border-radius: 6px;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    
    left: 100%;
}
.slider_sliderMid__boMQu {
    background: var(--color-132);
    display: inline-block;
    position: absolute;

    width: 6px;
    height: 6px;
    border-radius: 6px;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);

    left: 50%;
}
.slider_sliderStart__yk5Iq {
    background: var(--color-132);
    display: inline-block;
    position: absolute;

    width: 6px;
    height: 6px;
    border-radius: 6px;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);

    left: 0;
}
.slider_tick__gZuyA {
    background: rgba(16, 16, 16, 0.1);
    display: inline-block;
    position: absolute;

    width: 4px;
    height: 6px;
    border-radius: 6px;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Slider/slider.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;;IAElB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,cAAc;;IAEd,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;IACnB,MAAM;AACV;AACA;IACI,4BAA4B;IAC5B,kCAAkC;IAClC,qBAAqB;IACrB,kBAAkB;;IAElB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,QAAQ;IACR,qCAAqC;AACzC;AACA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;;IAElB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;;IAErC,UAAU;AACd;AACA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;;IAElB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;;IAErC,SAAS;AACb;AACA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;;IAElB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;;IAErC,OAAO;AACX;AACA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,kBAAkB;;IAElB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;AACzC","sourcesContent":[".slider {\n    margin: 7px 6px;\n    position: relative;\n    background: var(--color-136);\n    -ms-touch-action: none;\n    touch-action: none;\n\n    height: 6px;\n    border-radius: 2px;\n    cursor: pointer;\n}\n.sliderFill {\n    display: block;\n\n    height: 100%;\n    background-color: var(--color-101);\n    border-radius: 10px;\n    top: 0;\n}\n.sliderHandle {\n    background: var(--color-106);\n    border: 2px solid var(--color-113);\n    display: inline-block;\n    position: absolute;\n\n    width: 12px;\n    height: 12px;\n    border-radius: 12px;\n    top: 50%;\n    transform: translate3d(-50%, -50%, 0);\n}\n.sliderEnd {\n    background: var(--color-132);\n    display: inline-block;\n    position: absolute;\n\n    width: 6px;\n    height: 6px;\n    border-radius: 6px;\n    top: 50%;\n    transform: translate3d(-50%, -50%, 0);\n    \n    left: 100%;\n}\n.sliderMid {\n    background: var(--color-132);\n    display: inline-block;\n    position: absolute;\n\n    width: 6px;\n    height: 6px;\n    border-radius: 6px;\n    top: 50%;\n    transform: translate3d(-50%, -50%, 0);\n\n    left: 50%;\n}\n.sliderStart {\n    background: var(--color-132);\n    display: inline-block;\n    position: absolute;\n\n    width: 6px;\n    height: 6px;\n    border-radius: 6px;\n    top: 50%;\n    transform: translate3d(-50%, -50%, 0);\n\n    left: 0;\n}\n.tick {\n    background: rgba(16, 16, 16, 0.1);\n    display: inline-block;\n    position: absolute;\n\n    width: 4px;\n    height: 6px;\n    border-radius: 6px;\n    top: 50%;\n    transform: translate3d(-50%, -50%, 0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slider": `slider_slider__MT8eV`,
	"sliderFill": `slider_sliderFill__t6rjG`,
	"sliderHandle": `slider_sliderHandle__oh-8Q`,
	"sliderEnd": `slider_sliderEnd__Y6hK7`,
	"sliderMid": `slider_sliderMid__boMQu`,
	"sliderStart": `slider_sliderStart__yk5Iq`,
	"tick": `slider_tick__gZuyA`
};
export default ___CSS_LOADER_EXPORT___;
